import { t } from "@travily/i18n";
import communityIllustration from "@ui/assets/illustrations/community-animated.webp";
import { NumberStepper } from "@ui/components/NumberStepper";
import { Wizard } from "@ui/components/Wizard";
import type { ReactNode } from "react";

const COLOR = "yellow" as const;

export interface ScaleStepViewProps {
  /** Current stage, 1-indexed. */
  currentStage: number;
  /** Total stages in the wizard. */
  totalStages: number;
  /** Number of hubs operated, bound to the stepper. */
  value: number;
  /** Field-level validation error to surface beneath the stepper, when present. */
  error?: string;
  /** Whether the primary (continue) action is in-flight. */
  primaryPending: boolean;
  /** Tertiary top-bar actions (e.g. Questions / Save and finish later). */
  topBarActions: ReactNode;
  /** Back affordance handler; omit on the first stage to hide it. */
  onBack?: () => void;
  /** Advance to the next stage. */
  onPrimary: () => void;
  /** Called with the new hub count when the stepper changes. */
  onValueChange: (value: number) => void;
}

export function ScaleStepView({
  currentStage,
  totalStages,
  value,
  error,
  primaryPending,
  topBarActions,
  onBack,
  onPrimary,
  onValueChange,
}: ScaleStepViewProps) {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={communityIllustration} />}
        heading={t("web.founding_members.creator.steps.community.scale.show.title")}
      >
        <NumberStepper
          aria-label={t("web.founding_members.creator.steps.community.scale.show.aria_label")}
          errorMessage={error}
          isInvalid={error != null}
          max={99}
          min={1}
          onChange={onValueChange}
          value={value}
        />
      </Wizard.Stage>
    </Wizard>
  );
}
